angular.module('gym.components').directive('signedWaiverEmergencyContactDetail', function() {
  return {
    restrict: 'EA',
    scope: {
      waiver: '=',
      collapsible: '=',
      defaultCollapsed: '='
    },
    template: require('templates/components/waivers/signed_waiver_emergency_contact_detail.html.slim')
  };
});
